import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";
import Swal from 'sweetalert2';
import { Container, Card, Form, Button, Modal, Spinner, Badge, Row, Col } from 'react-bootstrap';
import './checklist.css';

function LoadingOverlay({ show, message }) {
    if (!show) return null;
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(255,255,255,0.9)', zIndex: 99999,
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
        }}>
            <Spinner animation="border" style={{ color: '#8b0000', width: '3.5rem', height: '3.5rem' }} />
            <span className="mt-3 fw-bold text-danger italic">{message || "Carregando..."}</span>
        </div>
    );
}

function CadastroItem() {
    const [descricao, setDescricao] = useState("");
    const [tipoEquipamento, setTipoEquipamento] = useState("");
    
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");
    
    const [itens, setItens] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [itemParaAssociar, setItemParaAssociar] = useState(null);
    const [lojasSelecionadas, setLojasSelecionadas] = useState([]);
    
    const navigate = useNavigate();
    const chapa = localStorage.getItem("chapa");
    const permiteCadastroCheckTI = localStorage.getItem("TICADCHECKLIST");
    
    const tiposDeEquipamento = [
        "DESKTOP", "CANCELA", "COLETOR", "IMPRESSORA", "TIRA-TEIMA","ROTEADOR WIFI", "SWITCH", "RAMAL", "CELULAR",
        "BALANÇA", "SOM", "TV", "PDV", "REP"
    ];

    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
            return;
        } else if (permiteCadastroCheckTI !== "S") {
            Swal.fire({ icon: 'error', title: 'Acesso Negado', text: 'Não é permitido acessar o cadastro de CheckList.', confirmButtonText: 'OK' })
                .then(() => navigate("/arbor/home"));
        }
        
        const carregarDados = async () => {
            try {
                setLoading(true);
                setLoadingMessage("Carregando itens e lojas...");
                
                const [lojasRes, itensRes] = await Promise.all([
                    api.get("lojas/localizacao"),
                    api.get("/checklist/itens")
                ]);
                
                const lojasPermitidas = lojasRes.data.filter(l => l.cod_emp < 50 && l.cod_emp !== 1 && l.cod_emp !== 23);
                setLojas(lojasPermitidas);
                setItens(itensRes.data);
                
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
                Swal.fire('Erro', 'Não foi possível carregar os dados.', 'error');
            } finally {
                setLoading(false);
            }
        };
        
        carregarDados();
    }, [chapa, navigate, permiteCadastroCheckTI]);

    const handleCadastrar = async (event) => {
        event.preventDefault(); 
        
        if (!descricao || !tipoEquipamento) {
            Swal.fire('Aviso', 'Preencha a descrição e o tipo de equipamento.', 'warning');
            return;
        }

        try {
            setLoading(true);
            setLoadingMessage("Cadastrando item de checklist...");

            const response = await api.post('/checklist/item', {
                descricao: descricao,
                tipoEquipamento: tipoEquipamento,
            });

            const novoItem = { id_item: response.data.id_item, descricao, tipo_equipamento: tipoEquipamento };
            
            Swal.fire('Sucesso!', `Item cadastrado com sucesso! ID: ${novoItem.id_item}`, 'success');
            
            setItens([novoItem, ...itens]);
            setDescricao("");
            setTipoEquipamento("");

        } catch (error) {
            console.error("Erro no cadastro:", error);
            const errorMessage = error.response?.data?.erro || "Ocorreu um erro ao processar a requisição.";
            Swal.fire('Erro', errorMessage, 'error');
        } finally {
            setLoading(false);
        }
    };
    
    const handleAbrirModal = async (item) => {
        setItemParaAssociar(item);
        
        try {
            setLoading(true);
            setLoadingMessage("Buscando associações atuais...");
            const res = await api.get(`/checklist/item/${item.id_item}/lojas`);
            setLojasSelecionadas(res.data.map(loja => String(loja.id_loja)));
        } catch (error) {
             if (error.response?.status === 404) {
                 setLojasSelecionadas([]);
             } else {
                 console.error("Erro ao carregar associações:", error);
                 Swal.fire('Erro', 'Não foi possível carregar as associações atuais do item.', 'error');
             }
        } finally {
            setLoading(false);
            setShowModal(true);
        }
    };

    const handleFecharModal = () => {
        setShowModal(false);
        setLojasSelecionadas([]);
        setItemParaAssociar(null);
    };

    const handleLojaChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            setLojasSelecionadas([...lojasSelecionadas, value]);
        } else {
            setLojasSelecionadas(lojasSelecionadas.filter(id => id !== value));
        }
    };
    
    const handleMarcarTodas = () => {
        const todosCodEmp = lojas.map(loja => String(loja.cod_emp));
        setLojasSelecionadas(todosCodEmp);
    };

    const handleDesmarcarTodas = () => {
        setLojasSelecionadas([]);
    };

    const handleSalvarAssociacoes = async () => {
        if (!itemParaAssociar) return;
        
        try {
            setLoading(true);
            setLoadingMessage("Salvando associações...");

            let associacoesAtuais = [];
            try {
                const res = await api.get(`/checklist/item/${itemParaAssociar.id_item}/lojas`);
                associacoesAtuais = res.data.map(loja => String(loja.id_loja));
            } catch (e) { }
            
            const paraAdicionar = lojasSelecionadas.filter(id => !associacoesAtuais.includes(id));
            const paraRemover = associacoesAtuais.filter(id => !lojasSelecionadas.includes(id));

            const promises = [];
            
            for (const idLoja of paraAdicionar) {
                promises.push(api.post('/checklist/vincularitem', { loja: parseInt(idLoja), item: itemParaAssociar.id_item }));
            }
            
            for (const idLoja of paraRemover) {
                promises.push(api.delete(`/checklist/desvincularitem/${idLoja}/${itemParaAssociar.id_item}`));
            }

            if (promises.length > 0) {
                await Promise.all(promises);
                Swal.fire('Sucesso!', 'Associações salvas com sucesso.', 'success');
            } else {
                Swal.fire('Aviso', 'Nenhuma alteração a ser salva.', 'info');
            }
            
        } catch (error) {
            console.error("Erro ao salvar associações:", error);
            Swal.fire('Erro', 'Ocorreu um erro ao salvar as associações.', 'error');
        } finally {
            setLoading(false);
            handleFecharModal();
        }
    };
    
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <Menu modulo="ARBOR" />
            <Container fluid className="px-4 mt-4 pt-4 mb-5" style={{ flex: 1, maxWidth: '1000px' }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="fw-bold text-dark m-0">
                        <i className="fa-solid fa-boxes-packing me-2 text-danger"></i>Gerenciar Itens de Checklist
                    </h4>
                </div>

                <Card className="shadow-sm border-0 bg-white rounded-3 mb-4 p-4">
                    <Form onSubmit={handleCadastrar}>
                        <Row className="g-3 align-items-end">
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Descrição do Item</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ex: Teclado PDV 01 Limpo e Operacional"
                                    value={descricao}
                                    onChange={e => setDescricao(e.target.value)}
                                    required
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Label className="small fw-bold">Tipo de Equipamento</Form.Label>
                                <Form.Select
                                    value={tipoEquipamento}
                                    onChange={e => setTipoEquipamento(e.target.value)}
                                    required
                                >
                                    <option value="">Selecione o Tipo...</option>
                                    {tiposDeEquipamento.map(tipo => (
                                        <option key={tipo} value={tipo}>{tipo}</option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={2}>
                                <Button
                                    type="submit"
                                    variant="danger"
                                    className="btn-arbor-primary w-100 fw-bold"
                                    disabled={loading}
                                >
                                    <i className="fa-solid fa-plus me-1"></i>Cadastrar
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Card>

                <h5 className="fw-bold mb-3 text-dark">
                    <i className="fa-solid fa-list me-2 text-danger"></i>Itens Cadastrados
                </h5>
                <Card className="shadow-sm border-0 bg-white rounded-3 overflow-hidden">
                    <div className="list-group list-group-flush">
                        {itens.length > 0 ? (
                            itens.map(item => (
                                <div key={item.id_item} className="list-group-item d-flex justify-content-between align-items-center p-3">
                                    <div>
                                        <div className="fw-bold text-dark">{item.descricao}</div>
                                        <Badge bg="danger" className="btn-arbor-primary mt-1">{item.tipo_equipamento}</Badge>
                                    </div>
                                    <Button
                                        size="sm"
                                        variant="outline-danger"
                                        className="btn-arbor-outline"
                                        onClick={() => handleAbrirModal(item)}
                                    >
                                        <i className="fa-solid fa-store me-1"></i>Associar Lojas
                                    </Button>
                                </div>
                            ))
                        ) : (
                            <div className="text-center text-muted py-5">
                                Nenhum item de checklist cadastrado.
                            </div>
                        )}
                    </div>
                </Card>
            </Container>

            <Modal show={showModal} onHide={handleFecharModal} size="lg" centered>
                <Modal.Header closeButton className="modal-header-arbor">
                    <Modal.Title className="h6 fw-bold text-white">
                        Associar Lojas a: {itemParaAssociar?.descricao}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    <div className="d-flex justify-content-end mb-2 gap-2">
                        <Button variant="outline-danger" size="sm" onClick={handleMarcarTodas}>
                            Marcar Todas
                        </Button>
                        <Button variant="outline-secondary" size="sm" onClick={handleDesmarcarTodas}>
                            Desmarcar Todas
                        </Button>
                    </div>
                    <div className="border rounded p-3 bg-light" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                        {lojas.length > 0 ? (
                            lojas.map(loja => (
                                <div key={loja.cod_emp} className="form-check mb-2">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={loja.cod_emp}
                                        id={`lojaCheck-${loja.cod_emp}`}
                                        onChange={handleLojaChange}
                                        checked={lojasSelecionadas.includes(String(loja.cod_emp))}
                                    />
                                    <label className="form-check-label fw-bold text-dark small" htmlFor={`lojaCheck-${loja.cod_emp}`}>
                                        Loja {String(loja.cod_emp).padStart(2, '0')} - {loja.razao}
                                    </label>
                                </div>
                            ))
                        ) : (
                            <div className="text-center text-muted">Carregando lojas...</div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleFecharModal}>
                        Cancelar
                    </Button>
                    <Button variant="danger" className="btn-arbor-primary" onClick={handleSalvarAssociacoes} disabled={loading}>
                        {loading ? 'Salvando...' : 'Salvar Associações'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <LoadingOverlay show={loading} message={loadingMessage} />
            <Footer />
        </div>
    );
}

export default CadastroItem;